import { Pipe, PipeTransform } from '@angular/core';

import { Feature } from '@vi-iot/client';

@Pipe({
  name: 'executable',
})
export class ExecutablePipe implements PipeTransform {
  transform(feature: Feature<unknown, unknown>, ...args: any[]): boolean {
    if (!args || !args[0]) {
      return false;
    }
    const command = args[0];

    return !!(
      feature &&
      feature.commands &&
      feature.commands[command] &&
      feature.commands[command].isExecutable
    );
  }
}
